import CallOutlinedIcon from "@mui/icons-material/CallOutlined";
import CloseIcon from "@mui/icons-material/Close";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import MenuIcon from "@mui/icons-material/Menu";
import {
  AppBar,
  Box,
  Button,
  Container,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Toolbar,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
// import logoMain from "../../assets/logoMain.png";
import logoMain from "../../assets/logoPng.png";

const menuItems = [
  { label: "Home", path: "/", target: false },
  { label: "About Us", path: "/about", target: false },
  { label: "Agents", path: "/agents", target: false },
  {
    label: "Find Us On Bayut",
    path: "https://www.bayut.com/companies/vision-x-nexus-real-estate-104238",
    target: true,
  },
];

const toolsMenu = [{ label: "ROI Calculator", path: "/tools/roi-calculator" }];

export default function Navbar() {
  const location = useLocation();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [toolsOpen, setToolsOpen] = useState(false);

  const isToolsActive = location.pathname.startsWith("/tools");

  useEffect(() => {
    if (isToolsActive) setToolsOpen(true);
  }, [isToolsActive]);

  // Scroll shadow
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      {/* ================= DESKTOP NAVBAR ================= */}
      {/* <AppBar
        position="fixed"
        elevation={0}
        sx={{
          backgroundColor: "var(--color-primary-dark)",
          borderBottom: "1px solid var(--color-gold)",
          boxShadow: scrolled ? "0 8px 30px rgba(0,0,0,0.35)" : "none",
          transition: "all 0.3s ease",
        }}
      > */}
      <AppBar
        position="fixed"
        elevation={0}
        sx={{
          backgroundColor: "var(--color-bg)",
          borderBottom: "1px solid var(--color-gold)",
          boxShadow: scrolled ? "0 6px 24px rgba(0,0,0,0.12)" : "none",
          transition: "all 0.3s ease",
        }}
      >
        <Container maxWidth="xl">
          <Toolbar
            disableGutters
            sx={{
              // height: 90,
              height: { xs: 60, md: 60 },
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            {/* LOGO */}
            <Box component={Link} to="/" sx={{ display: "flex" }}>
              <Box
                component="img"
                src={logoMain}
                alt="Vision X Nexus"
                sx={{
                  // height: { xs: 36, md: 46 },
                  height: { xs: 36, md: 38 },
                  width: "auto",
                  objectFit: "contain",
                }}
              />
            </Box>

            {/* DESKTOP MENU */}
            <Box sx={{ display: { xs: "none", md: "flex" }, gap: 5 }}>
              {menuItems.map((item) => {
                const isActive = location.pathname === item.path;

                return (
                  <Typography
                    key={item.path}
                    component={Link}
                    target={item?.target ? "_blank" : "_self"}
                    to={item.path}
                    sx={{
                      textDecoration: "none",
                      fontSize: 14,
                      letterSpacing: "0.12em",
                      position: "relative",
                      color: "var(--color-text-primary)",

                      "&::after": {
                        content: '""',
                        position: "absolute",
                        left: 0,
                        bottom: -8,
                        width: isActive ? "100%" : "0%",
                        height: "2px",
                        backgroundColor: "var(--color-gold)",
                        transition: "0.3s",
                      },

                      // color: "var(--color-white)",
                      // "&::after": {
                      //   content: '""',
                      //   position: "absolute",
                      //   left: 0,
                      //   bottom: -8,
                      //   width: isActive ? "100%" : "0%",
                      //   height: "2px",
                      //   backgroundColor: "var(--color-gold)",
                      //   transition: "0.3s",
                      // },
                      "&:hover::after": {
                        width: "100%",
                      },
                    }}
                  >
                    {item.label}
                  </Typography>
                );
              })}

              {/* TOOLS DROPDOWN */}
              <Box
                sx={{
                  position: "relative",
                  "&:hover .tools-dropdown": {
                    opacity: 1,
                    visibility: "visible",
                    transform: "translateY(0)",
                  },
                }}
              >
                {/* TOOLS LABEL */}
                <Typography
                  sx={{
                    fontSize: 14,
                    letterSpacing: "0.12em",
                    cursor: "pointer",
                    position: "relative",
                    color: "var(--color-text-primary)",

                    "&::after": {
                      content: '""',
                      position: "absolute",
                      left: 0,
                      bottom: -8,
                      width: location.pathname.startsWith("/tools")
                        ? "100%"
                        : "0%",
                      height: "2px",
                      backgroundColor: "var(--color-gold)",
                      transition: "0.3s",
                    },

                    "&:hover::after": {
                      width: "100%",
                    },
                  }}
                >
                  Tools
                </Typography>

                {/* DROPDOWN */}
                <Box
                  className="tools-dropdown"
                  sx={{
                    position: "absolute",
                    top: "calc(100% + 16px)",
                    left: 0,
                    minWidth: 220,
                    backgroundColor: "var(--color-white)",
                    borderRadius: "12px",
                    boxShadow: "0 20px 60px rgba(0,0,0,0.15)",
                    padding: "10px 0",
                    opacity: 0,
                    visibility: "hidden",
                    transform: "translateY(8px)",
                    transition: "0.25s ease",
                    zIndex: 1000,
                  }}
                >
                  {toolsMenu.map((tool) => {
                    const isToolActive = location.pathname === tool.path;

                    return (
                      <Typography
                        key={tool.path}
                        component={Link}
                        to={tool.path}
                        sx={{
                          display: "block",
                          px: 3,
                          py: 1.2,
                          fontSize: 13,
                          textDecoration: "none",
                          letterSpacing: "0.08em",
                          position: "relative",

                          color: isToolActive
                            ? "var(--color-gold)"
                            : "var(--color-text-primary)",

                          backgroundColor: isToolActive
                            ? "rgba(207, 172, 106, 0.12)"
                            : "transparent",

                          "&:hover": {
                            backgroundColor: "rgba(0,0,0,0.04)",
                            color: "var(--color-gold)",
                          },

                          "&::after": {
                            content: '""',
                            position: "absolute",
                            left: 24,
                            bottom: 6,
                            width: isToolActive ? "calc(100% - 48px)" : "0%",
                            height: "1px",
                            backgroundColor: "var(--color-gold)",
                            transition: "0.3s",
                          },
                        }}
                      >
                        {tool.label}
                      </Typography>
                    );
                  })}
                </Box>
              </Box>
            </Box>

            {/* DESKTOP ACTIONS */}
            <Box sx={{ display: { xs: "none", md: "flex" }, gap: 2 }}>
              <Button
                component={Link}
                to="/contact"
                startIcon={<EmailOutlinedIcon />}
                sx={{
                  backgroundColor: "var(--color-white)",
                  color: "var(--color-text-primary)",
                  // px: 3.2,
                  // py: 1.4,
                  px: 2.6,
                  py: 1.1,
                  fontSize: 13,
                  borderRadius: "999px",
                  textTransform: "none",
                  // fontSize: 14,
                  fontWeight: 500,
                  border: "1px solid rgba(0,0,0,0.08)",
                  boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
                  transition: "all 0.3s ease",

                  "& .MuiButton-startIcon": {
                    color: "var(--color-gold)",
                  },

                  "&:hover": {
                    backgroundColor: "var(--color-bg)",
                    boxShadow: "0 10px 28px rgba(0,0,0,0.12)",
                    transform: "translateY(-1px)",
                  },
                }}
              >
                Contact Us
              </Button>

              <Button
                component="a"
                href="tel:+971547914848"
                startIcon={<CallOutlinedIcon />}
                sx={{
                  border: "1px solid var(--color-gold)",
                  color: "var(--color-gold)",
                  // px: 3,
                  // py: 1.4,
                  px: 2.6,
                  py: 1.1,
                  fontSize: 13,

                  borderRadius: "40px",
                  textTransform: "none",
                  "&:hover": {
                    backgroundColor: "rgba(201,162,77,0.08)",
                  },
                }}
              >
                Call Us
              </Button>
            </Box>

            {/* MOBILE MENU ICON */}
            <IconButton
              sx={{
                display: { xs: "flex", md: "none" },
                color: "var(--color-gold)",
              }}
              onClick={() => setDrawerOpen(true)}
            >
              <MenuIcon />
            </IconButton>
          </Toolbar>
        </Container>
      </AppBar>

      {/* ================= MOBILE DRAWER ================= */}
      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
      >
        <Box
          sx={{
            width: 300,
            height: "100%",
            backgroundColor: "var(--color-bg)",
            color: "var(--color-text-primary)",

            // backgroundColor: "var(--color-primary-dark)",
            // color: "var(--color-white)",
            p: 3,
            display: "flex",
            flexDirection: "column",
          }}
        >
          {/* TOP (LOGO + CLOSE) */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              mb: 4,
            }}
          >
            <Box
              component="img"
              src={logoMain}
              alt="Vision X Nexus"
              sx={{ height: 34, objectFit: "contain" }}
            />

            <IconButton
              onClick={() => setDrawerOpen(false)}
              sx={{ color: "var(--color-gold)" }}
            >
              <CloseIcon />
            </IconButton>
          </Box>

          {/* MENU ITEMS */}
          <List sx={{ mb: 4 }}>
            {menuItems.map((item) => (
              <ListItem
                key={item.path}
                component={Link}
                target={item?.target ? "_blank" : "_self"}
                to={item.path}
                onClick={() => setDrawerOpen(false)}
                sx={{
                  textDecoration: "none",
                  // color:
                  //   location.pathname === item.path
                  //     ? "var(--color-gold)"
                  //     : "var(--color-white)",
                  py: 1.6,
                  // borderLeft:
                  //   location.pathname === item.path
                  //     ? "3px solid var(--color-gold)"
                  //     : "3px solid transparent",
                  // backgroundColor:
                  //   location.pathname === item.path
                  //     ? "rgba(201,162,77,0.08)"
                  //     : "transparent",
                  color:
                    location.pathname === item.path
                      ? "var(--color-primary-dark)"
                      : "var(--color-text-primary)",

                  borderLeft:
                    location.pathname === item.path
                      ? "3px solid var(--color-gold)"
                      : "3px solid transparent",

                  backgroundColor:
                    location.pathname === item.path
                      ? "rgba(207,172,106,0.12)"
                      : "transparent",

                  transition: "all 0.3s ease",
                }}
              >
                <ListItemText
                  primary={item.label}
                  primaryTypographyProps={{
                    fontSize: 16,
                    letterSpacing: "0.08em",
                    fontWeight: location.pathname === item.path ? 600 : 400,
                  }}
                />
              </ListItem>
            ))}
            {/* TOOLS (PARENT ITEM) */}
            <ListItem
              onClick={() => setToolsOpen(!toolsOpen)}
              sx={{
                py: 1.6,
                cursor: "pointer",
                color: isToolsActive
                  ? "var(--color-primary-dark)"
                  : "var(--color-text-primary)",

                borderLeft: isToolsActive
                  ? "3px solid var(--color-gold)"
                  : "3px solid transparent",

                backgroundColor: isToolsActive
                  ? "rgba(207,172,106,0.12)"
                  : "transparent",
              }}
            >
              <ListItemText
                primary="Tools"
                primaryTypographyProps={{
                  fontSize: 16,
                  letterSpacing: "0.08em",
                  fontWeight: isToolsActive ? 600 : 400,
                }}
              />
            </ListItem>

            {/* TOOLS CHILD ITEMS */}
            {toolsOpen &&
              toolsMenu.map((tool) => {
                const isToolActive = location.pathname === tool.path;

                return (
                  <ListItem
                    key={tool.path}
                    component={Link}
                    to={tool.path}
                    onClick={() => setDrawerOpen(false)}
                    sx={{
                      pl: 4.5,
                      py: 1.3,
                      textDecoration: "none",
                      color: isToolActive
                        ? "var(--color-gold)"
                        : "var(--color-text-muted)",

                      backgroundColor: isToolActive
                        ? "rgba(207,172,106,0.12)"
                        : "transparent",

                      borderLeft: isToolActive
                        ? "3px solid var(--color-gold)"
                        : "3px solid transparent",

                      transition: "all 0.3s ease",
                    }}
                  >
                    <ListItemText
                      primary={tool.label}
                      primaryTypographyProps={{
                        fontSize: 14,
                        letterSpacing: "0.06em",
                        fontWeight: isToolActive ? 600 : 400,
                      }}
                    />
                  </ListItem>
                );
              })}
          </List>

          {/* ACTION BUTTONS */}
          <Button
            component={Link}
            to="/contact"
            fullWidth
            startIcon={<EmailOutlinedIcon />}
            sx={{
              backgroundColor: "var(--color-white)",
              color: "var(--color-text-primary)",
              py: 1.6,
              px: 2.5,
              borderRadius: "999px",
              textTransform: "none",
              fontSize: 15,
              fontWeight: 500,
              border: "1px solid rgba(0,0,0,0.08)",
              boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
              transition: "all 0.3s ease",

              "& .MuiButton-startIcon": {
                color: "var(--color-gold)",
              },

              "&:active": {
                transform: "scale(0.98)",
                boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
              },
              marginBottom: "10px",
            }}
            onClick={() => setDrawerOpen(false)}
          >
            Contact Us
          </Button>

          <Button
            fullWidth
            component="a"
            href="tel:+971547914848"
            startIcon={<CallOutlinedIcon />}
            sx={{
              border: "1px solid var(--color-gold)",
              color: "var(--color-gold)",
              py: 1.4,
              borderRadius: "30px",
              textTransform: "none",
              textDecoration: "none",
              "&:hover": {
                borderColor: "var(--color-gold)",
                backgroundColor: "rgba(247, 148, 29, 0.08)", // subtle luxury hover
              },
            }}
          >
            Call Us
          </Button>
        </Box>
      </Drawer>
    </>
  );
}
